import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import loader from '../assets/loader.gif';


const RouteLoader = () => {
  const [routeLoading, setRouteLoading] = useState(false);
  const location = useLocation();
  const isLoading  = useSelector((state) => state.privateReducer.isLoading);
  const isLoading1  = useSelector((state) => state.pollWeb.isLoading);
  const isLoading2  = useSelector((state) => state.publicReducer.isLoading);

  const MIN_LOADING_TIME = 700; // 0.5 seconds minimum

  useEffect(() => {
    setRouteLoading(true);
    const timer = setTimeout(() => {
      setRouteLoading(false);
    }, MIN_LOADING_TIME);

    return () => clearTimeout(timer);
  }, [location.pathname]);

   const showLoader = [routeLoading, isLoading, isLoading1, isLoading2].some(Boolean);
   console.log("🚀 ~ RouteLoader ~ showLoader:", showLoader)

  if (!showLoader) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-75">
      <img src={loader} alt="Loading..." className="w-20 h-20" />
    </div>
  );
};

export default RouteLoader;